(function () {
  'use strict';

  var card = document.querySelector('[data-uc-floating-product]');
  if (!card || card.dataset.ucFloatingProductReady === 'true') return;
  card.dataset.ucFloatingProductReady = 'true';

  var closeButton = card.querySelector('[data-uc-floating-product-close]');
  var links = card.querySelectorAll('[data-uc-floating-product-link]');
  var sessionKey = card.dataset.sessionKey;
  var timerReady = false;
  var scrollReady = false;
  var displayed = false;
  var dismissed = false;
  var scrollTicking = false;
  var blockerObserver = null;
  var recentlyBought = document.getElementById('recently-bought--holder');

  function storageGet(key) {
    try {
      return window.sessionStorage.getItem(key);
    } catch (error) {
      return null;
    }
  }

  function storageSet(key, value) {
    try {
      window.sessionStorage.setItem(key, value);
    } catch (error) {
      // La fermeture reste valable pour la page courante si le stockage est indisponible.
    }
  }

  if (sessionKey && storageGet(sessionKey) === 'true') {
    card.remove();
    return;
  }

  function pageScrollProgress() {
    var root = document.documentElement;
    var pageHeight = Math.max(root.scrollHeight, document.body ? document.body.scrollHeight : 0);
    var scrollable = Math.max(pageHeight - window.innerHeight, 1);
    return Math.max(0, window.scrollY || root.scrollTop || 0) / scrollable;
  }

  function isVisibleElement(element) {
    if (!element) return false;
    var style = window.getComputedStyle(element);
    var rect = element.getBoundingClientRect();
    return style.display !== 'none' &&
      style.visibility !== 'hidden' &&
      parseFloat(style.opacity || '1') > 0.05 &&
      rect.width > 0 &&
      rect.height > 0 &&
      rect.bottom > 0 &&
      rect.top < window.innerHeight;
  }

  function updateFixedOffset() {
    if (!displayed || dismissed || !isVisibleElement(recentlyBought)) {
      card.style.removeProperty('--uc-floating-product-bottom');
      return;
    }

    var blockerRect = recentlyBought.getBoundingClientRect();
    var cardRect = card.getBoundingClientRect();
    var overlapsHorizontally = blockerRect.left < cardRect.right && blockerRect.right > cardRect.left;
    if (!overlapsHorizontally) {
      card.style.removeProperty('--uc-floating-product-bottom');
      return;
    }

    var safeGap = window.innerWidth <= 749 ? 12 : 16;
    var offset = Math.max(window.innerHeight - blockerRect.top + safeGap, safeGap);
    card.style.setProperty('--uc-floating-product-bottom', offset + 'px');
  }

  function watchFixedBlocker() {
    if (!recentlyBought || blockerObserver) return;
    blockerObserver = new MutationObserver(updateFixedOffset);
    blockerObserver.observe(recentlyBought, {
      attributes: true,
      attributeFilter: ['class', 'style', 'href']
    });
    recentlyBought.addEventListener('transitionstart', updateFixedOffset);
    recentlyBought.addEventListener('transitionend', updateFixedOffset);
  }

  function showCard() {
    if (displayed || dismissed || !timerReady || !scrollReady) return;
    displayed = true;
    card.hidden = false;
    card.setAttribute('aria-hidden', 'false');
    window.removeEventListener('scroll', onScroll);
    watchFixedBlocker();
    window.requestAnimationFrame(function () {
      card.classList.add('is-visible');
      updateFixedOffset();
    });
  }

  function checkScroll() {
    scrollTicking = false;
    if (pageScrollProgress() >= 0.25) {
      scrollReady = true;
      window.removeEventListener('scroll', onScroll);
      showCard();
    }
  }

  function onScroll() {
    if (scrollTicking) return;
    scrollTicking = true;
    window.requestAnimationFrame(checkScroll);
  }

  function dismissCard() {
    if (dismissed) return;
    dismissed = true;
    if (sessionKey) storageSet(sessionKey, 'true');
    window.removeEventListener('scroll', onScroll);
    window.removeEventListener('resize', updateFixedOffset);
    if (blockerObserver) blockerObserver.disconnect();
    card.classList.remove('is-visible');
    card.classList.add('is-closing');
    card.setAttribute('aria-hidden', 'true');
    window.setTimeout(function () {
      card.hidden = true;
    }, 230);
  }

  function trackProductClick(event) {
    var link = event.currentTarget;
    var detail = {
      component: 'article_floating_product',
      click_target: link.dataset.ucFloatingProductLink,
      article_id: card.dataset.articleId,
      article_handle: card.dataset.articleHandle,
      article_title: card.dataset.articleTitle,
      product_id: card.dataset.productId,
      product_handle: card.dataset.productHandle,
      product_title: card.dataset.productTitle,
      destination_url: link.href
    };

    if (Array.isArray(window.dataLayer)) {
      window.dataLayer.push(Object.assign({ event: 'floating_product_click' }, detail));
    }

    try {
      document.dispatchEvent(new CustomEvent('floating_product_click', { detail: detail }));
    } catch (error) {
      // Le clic et la navigation ne doivent jamais dépendre du tracking.
    }
  }

  if (closeButton) closeButton.addEventListener('click', dismissCard);
  Array.prototype.forEach.call(links, function (link) {
    link.addEventListener('click', trackProductClick);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && displayed && !dismissed) dismissCard();
  });
  window.addEventListener('resize', updateFixedOffset, { passive: true });
  window.addEventListener('scroll', onScroll, { passive: true });

  checkScroll();
  window.setTimeout(function () {
    timerReady = true;
    showCard();
  }, 15000);
})();
